import React from "react";
import "./App.css";

// HOC wrapped components
import ParentHoc from "./HOC/WrappedComponents/ParentHoc";
import ChildAHoc from "./HOC/WrappedComponents/ChildAHoc";
import ChildBHoc from "./HOC/WrappedComponents/ChildBHoc";

// Router components
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";

// UI Components
import Header from "./components/Header";
import Nav from "./components/Nav";
import DevStatus from "./components/DevStatus";
import Footer from "./components/Footer";
import Copy from "./components/Copy";

/**
 * Main App component
 * Demonstrates React Router with HOC-wrapped components
 * Each route renders a family member component enhanced by the Family HOC
 */
function App() {
  return (
    <div className="App">
      <Router>
        <Header />
        <Nav />

        <main className="container" role="main">
          <Switch>
            {/* Family member routes */}
            <Route
              path="/parent"
              component={ParentHoc}
              exact
            />
            <Route
              path="/childa"
              component={ChildAHoc}
              exact
            />
            <Route
              path="/childb"
              component={ChildBHoc}
              exact
            />

            {/* Dev Status page route */}
            <Route
              path="/dev-status"
              component={DevStatus}
              exact
            />

            {/* Default redirect to Parent */}
            <Route exact path="/">
              <Redirect to="/parent" />
            </Route>

            {/* 404 fallback */}
            <Route>
              <div className="text-center mt-5">
                <h2>Page Not Found</h2>
                <p>The requested page does not exist.</p>
              </div>
            </Route>
          </Switch>

          {/* Utility component */}
          <Copy />
        </main>

        <Footer />
      </Router>
    </div>
  );
}

export default App;